import Query from '@/core/lib/new-architecture/query';
import Store from '@/core/lib/new-architecture/store';
import type { StoreData } from '@/core/lib/new-architecture/store/store.types';
import { ActivityAlias } from '@/core/types/profile';

const useActivities = (): StoreData<{ [key in ActivityAlias]?: number }> => {
  const { requestToken } = Store.auth.useRequest();

  const { data, isLoading } = Query.user.activities.useActivities({ token: requestToken });

  const res = data?.types?.reduce((acc, { alias, points }) => ({ ...acc, [alias as ActivityAlias]: points }), {} as { [key in ActivityAlias]?: number });

  const notFound = !data && !isLoading;

  return {
    data: res || {},
    isLoading,
    notFound,
  };
};

export default { useActivities };
